<template>
  <div id="kpi2">
    <div class="box">
      <div id="chartkpi2" style="height: 100%"></div>
    </div>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from "echarts";

export default {
  name: "kpi2",
  data() {
    return {
      // 需要合并对象，样式
      legendColor: false,
      mm: 5,
      dataset: [],
      dataLabel: [],
      equipDesc: [],
      shadowBar: [],
    };
  },
  created() {},
  mounted() {},
  methods: {
    refreshChart(chartData) {
      console.log(chartData);
      const serColors = ["#1E90FF", "#008B45", "#99d0b9", "#8E8E38", "#6aa36a"];
      var that = this;
      const data1 = [];
      const data2 = [];
      const data3 = [];
      const titleData = [];
      const equipDesc = [];
      this.dataset = [];
      this.shadowBar = [];
      for (var i = 0; i < chartData.length; i++) {
        data1.push(chartData[i].Key);
      
        data2.push(chartData[i].KpiArr);
      }
      this.dataset = [data1, data2];
  console.log("itemKeyLength", chartData.length);
  console.log("itemKey", data1);
      var myChart = echarts.init(document.getElementById("chartkpi2"));
      myChart.clear();

      var zoomConfig = [];
      if (data1.length > 8) {
        zoomConfig.push({
          type: "inside",
          start: 0,
          end: (8 / data1.length) * 100,
        });
      }

      var option = {
        title: {
          text: "空压机KPI",
          textStyle: {
            color: "#fff",
            fontSize: 24,
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: ["KPI", "公斤单耗", "模单耗"],
          x: "right",
          textStyle: {
            color: "#fff",
            fontSize: 16,
          },
        },
        grid: {
          left: "6%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: data1,
            axisTick: {
              alignWithLabel: true,
              interval: 0
            },
            axisLabel: {
              interval: 0,
              color: '#fff',
              fontSize: 12
            },
            axisLine: {
              // 轴线
              lineStyle: {
                color: '#7f8fa4'
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#fff",
              fontSize: 16,
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#7f8fa4",
              },
            },
          },
        ],
        series: [
          {
            name: "KPI",
            type: "line",
            data: this.dataset[1],
            color: serColors[0],
            xAxisIndex: 0,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "top",
                  textStyle: {
                    color: "#fff",
                    fontSize: 14,
                  },
                },
              },
            },
            symbol: "diamond",
          },
        ],
      };
      // 5：展示数据
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped >
#kpi2 {
  position: relative;
  width: 100%;
  height: 95%;
  box-sizing: border-box;
  .box {
    width: 100%;
    height: 100%;
  }
}
</style>
